<template>
  <div>
    <title-component :size="1" :lineSeparator="'under'">
      <translate>Welcome to Kiwa Certification</translate>
    </title-component>
    <div class="columns section-bordered">
      <!-- Form panel -->
      <div v-if="!submitted" class="column is-6">
        <title-component :size="4">
          <translate>Create or reset passwords via social security number</translate>
          <template slot="subtitle">
            <translate>
              If you do not know which e-mail address you have in the portal, we can send a mail
              to the e-mail address below given your social security number.
            </translate>
          </template>
        </title-component>
        <!-- Reset password form -->
        <template v-if="formDescriptors && formDatas">
          <form-component
            v-for="formDescriptor in formDescriptors"
            :formDescriptor="formDescriptor"
            :formData="getFormDataForDescriptor(formDescriptor)"
            :key="formDescriptor.id"
            class="reset-password-ssn-form">
          </form-component>
        </template>
        <!-- Non field error handling -->
        <transition
          name="fade"
          appear
          appear-active-class="animated fadeIn"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 200, leave: 200 }">
          <div v-if="mixin.error" class="notification is-danger">
            {{ mixin.error }}
          </div>
        </transition>

        <div class="">
          <submit-btn-component
            ref="enterButton"
            class="is-primary submit-button is-large is-uppercase center-vertically"
            @submit="submitSaveResetPasswordForm"
            v-translate>
            Reset password
          </submit-btn-component>
        </div>
      </div>

      <!-- Success panel -->
      <div v-else class="column is-6">
        <title-component :size="4">
          <translate>Create or reset passwords via social security number</translate>
        </title-component>
        <message-component class="message" :level="'success'">
          <translate>
            If that social security number is registered, an email has been
            sent to the registered address.
          </translate>
        </message-component>
        <div class="btns-container">
          <router-link
            class="button is-uppercase is-success is-outlined"
            :to="{ name: 'WelcomeView'}"
            v-translate>
            Go to start page
          </router-link>
        </div>
      </div>
    </div>
    <!-- Browser compatiblity check -->
    <browser-compatibility-component />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import TitleComponent from '@/components/layout/TitleComponent.vue'
  import { formHandlerMixin, onKeyEnterMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'
  import BrowserCompatibilityComponent from '@/components/layout/BrowserCompatibilityComponent'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'reset-password-ssn-view',
    mixins: [onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin],
    data () {
      return {
        submitRequest: null,
        submitted: false
      }
    },
    components: {
      TitleComponent,
      SubmitBtnComponent,
      FormComponent,
      BrowserCompatibilityComponent,
      MessageComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.authModule.formDescriptors,
        formDatas: state => state.authModule.formDatas
      })
    },
    methods: {
      ...mapActions([
        'setupResetPasswordSSNForm',
        'saveResetPasswordSSNForm',
        'clearData'
      ]),
      submitSaveResetPasswordForm (btn) {
        let requestData = {
          formDatas: this.formDatas
        }
        this.submitRequest = this.saveResetPasswordSSNForm
        this.submitForm(requestData, btn).then(response => {
          // The response is deliberately identical whether or not the number
          // is registered, so success is driven by the request completing.
          this.submitted = !!response
        })
      }
    },
    created () {
      this.setupResetPasswordSSNForm().catch((err) => {
        this.handleError(err)
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
  .reset-password-ssn-form
    margin-top: 0
  .link
    display: inline-block
    margin: 0 0.5rem
  .message
    margin-top: 3rem
</style>
